import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { StoreData } from '../../reducers/typings'
import { loadFilterPreferences } from '@user/store/userPreferences'
import { Duplicate } from '@user/query/useDuplicateCheck'

export type WorkWaveContactPageState = {
  page: number
  perPage: number
  orderBy: string
  searchText: string
  resultCount: number
  duplicates: Duplicate[]
}

const WorkWaveContactDuplicateAdapter = createEntityAdapter<Duplicate>()

export const initialState =
  WorkWaveContactDuplicateAdapter.getInitialState<WorkWaveContactPageState>({
    page: 1,
    perPage: 10,
    orderBy: 'firstName desc',
    duplicates: [],
    resultCount: 0,
    searchText: '',
  })

const WorkWaveContactDuplicateSlice = createSlice({
  name: 'WorkWaveContactDuplicateSlice',
  initialState,
  reducers: {
    setWorkWaveContactDuplicates: (state, { payload }: PayloadAction<any>) => {
      state.page = payload.page || 1
      state.perPage = payload.perPage
      state.orderBy = payload.orderBy
      state.duplicates = payload.duplicates.map((item: Duplicate) => {
        return {
          ...item,
          id: item.id + '-' + crypto.randomUUID(),
        }
      })
      state.resultCount = payload.resultCount
    },
    setOrderBy: (state, { payload }: PayloadAction<string>) => {
      state.orderBy = payload
    },
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload
    },
    setPerPage: (state, { payload }: PayloadAction<number>) => {
      state.perPage = payload
    },
    setSearch: (state, { payload }: PayloadAction<string>) => {
      state.searchText = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadFilterPreferences.fulfilled, (state, { payload }) => {
      const userPref = payload.find(
        (p) => p.type === 'workWaveContactDuplicates',
      )
      state.orderBy = userPref
        ? JSON.parse(userPref.filter).orderBy
        : 'firstName desc'
      return state
    })
  },
})

export const {
  setOrderBy,
  setPage,
  setPerPage,
  setWorkWaveContactDuplicates,
  setSearch,
} = WorkWaveContactDuplicateSlice.actions

export default WorkWaveContactDuplicateSlice.reducer

const roleSelectors = WorkWaveContactDuplicateAdapter.getSelectors<StoreData>(
  (state) => state.workWaveContactDuplicates,
)

export const { selectAll: selectAllWorkWaveContactDuplicates } = roleSelectors

export const selectWorkWaveContactDuplicatesFilters = (state: StoreData) => {
  return state.workWaveContactDuplicates
}
